import React from 'react';
import { StyledTrainsOutbound } from '../BorderControlRequirement.styles';

const TrainOutboundIcon = () => (
  <StyledTrainsOutbound
    data-testid="TrainOutboundIcon"
    data-cy="TrainOutboundIcon"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_209_2014)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.04003 47.7001V45.2401H3.03003V12.15V10.3V9.69005V8.46005C3.71407 8.453 7.68533 8.46584 10.2163 8.47402C11.2744 8.47744 12.0807 8.48005 12.29 8.48005C14.55 8.43005 16.97 8.53005 19.28 8.75005C29.08 9.72005 39.28 12.72 46.48 19.77C46.7353 20.0222 47.0039 20.2855 47.2769 20.5532C47.8593 21.1243 48.4621 21.7153 49 22.26C52.36 25.65 55.72 29.09 58.61 32.92L58.6407 32.963C59.0309 33.5092 59.4285 34.0656 59.75 34.66C59.76 34.675 59.7675 34.69 59.775 34.705C59.7825 34.72 59.79 34.735 59.8 34.75C59.8 34.75 59.82 34.77 59.83 34.8C59.9015 34.9112 59.9604 35.0098 60.0267 35.1209C60.0439 35.1496 60.0615 35.1792 60.08 35.21C61.33 37.39 62.51 39.9901 62.43 42.5801C62.36 44.8801 60.98 46.6701 58.77 47.3301C57.59 47.7001 56.34 47.71 55.13 47.7001H53.05H3.04003ZM49.5 28.08L41.32 19.5H26.76C26.76 19.5 26.86 20.91 27.06 22.2C27.67 24.93 28.59 28.08 31.61 28.08H49.5ZM3.45003 54.6501L60.87 53.2401C61.34 53.2301 61.72 53.6001 61.72 54.0701V56.2101C61.72 56.6801 61.34 57.0501 60.87 57.0401L3.45003 55.6301C3.29003 55.6201 3.16003 55.4901 3.16003 55.3301V54.9501C3.16003 54.7901 3.29003 54.6501 3.45003 54.6501Z"
        fill="#00286A"
      />
    </g>
    <g clipPath="url(#clip1_209_2014)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.04003 47.7001V45.2401H3.03003V12.15V10.3V9.69005V8.46005C3.71407 8.453 7.68533 8.46584 10.2163 8.47402C11.2744 8.47744 12.0807 8.48005 12.29 8.48005C14.55 8.43005 16.97 8.53005 19.28 8.75005C29.08 9.72005 39.28 12.72 46.48 19.77C46.7353 20.0222 47.0039 20.2855 47.2769 20.5532C47.8593 21.1243 48.4621 21.7153 49 22.26C52.36 25.65 55.72 29.09 58.61 32.92L58.6407 32.963C59.0309 33.5092 59.4285 34.0656 59.75 34.66C59.76 34.675 59.7675 34.69 59.775 34.705C59.7825 34.72 59.79 34.735 59.8 34.75C59.8 34.75 59.82 34.77 59.83 34.8C59.9015 34.9112 59.9604 35.0098 60.0267 35.1209C60.0439 35.1496 60.0615 35.1792 60.08 35.21C61.33 37.39 62.51 39.9901 62.43 42.5801C62.36 44.8801 60.98 46.6701 58.77 47.3301C57.59 47.7001 56.34 47.71 55.13 47.7001H53.05H3.04003ZM49.5 28.08L41.32 19.5H26.76C26.76 19.5 26.86 20.91 27.06 22.2C27.67 24.93 28.59 28.08 31.61 28.08H49.5ZM3.45003 54.6501L60.87 53.2401C61.34 53.2301 61.72 53.6001 61.72 54.0701V56.2101C61.72 56.6801 61.34 57.0501 60.87 57.0401L3.45003 55.6301C3.29003 55.6201 3.16003 55.4901 3.16003 55.3301V54.9501C3.16003 54.7901 3.29003 54.6501 3.45003 54.6501Z"
        fill="#106DFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_209_2014">
        <rect width="29" height="49" fill="white" transform="translate(3 8)" />
      </clipPath>
      <clipPath id="clip1_209_2014">
        <rect width="30" height="49" fill="white" transform="translate(32 8)" />
      </clipPath>
    </defs>
  </StyledTrainsOutbound>
);

export default TrainOutboundIcon;
